export const USE_FIRST_AVAILABLE_PLAN_TOOLTIP =
  "If a product has multiple selling plans, we'll use the one ranked highest in your Shopify Subscriptions list";
